import React from 'react';
import PropTypes from 'prop-types';
/* components */
import Checkbox from '../checkbox/checkbox';
/* utils */
import keyCodes from '../../utils/key-codes';
/* styles */
import './flip-switch.scss';

const sizeMap = {
    xs: ' sten-flip-switch--xs'
};

class FlipSwitch extends React.PureComponent {
    state = {
        isFocused: false
    };

    handleToggle = (e) => {
        if (!this.props.disabled) {
            this.props.onChange(!this.props.isActive, e);
        }
    };

    onFocus = () => {
        if (!this.props.disabled) {
            this.setState({ isFocused: true });
        }
    };

    onBlur = () => { this.setState({ isFocused: false }); };

    handleKeyDown = e => {
        if (this.state.isFocused) {
            switch (e.keyCode) {
            case keyCodes.space:
                e.stopPropagation();
                this.handleToggle(e);
                break;
            case keyCodes.rightArrow:
                if (this.props.allowArrowKeys && !this.props.isActive) {
                    e.stopPropagation();
                    this.handleToggle(e);
                }
                break;
            case keyCodes.leftArrow:
                if (this.props.allowArrowKeys && this.props.isActive) {
                    e.stopPropagation();
                    this.handleToggle(e);
                }
                break;
            default:
            }
        }
    };

    render() {
        const valueLabels = {
            active: this.props.activeLabel,
            inactive: this.props.inactiveLabel,
            activeTitle: this.props.activeTitle || this.props.activeLabel,
            inactiveTitle: this.props.inactiveTitle || this.props.inactiveLabel
        };
        let value = valueLabels.inactive;
        let title = valueLabels.inactiveTitle;
        let classNames = 'sten-flip-switch';
        if (this.props.isActive) {
            classNames += ' sten-flip-switch--active';
            value = valueLabels.active;
            title = valueLabels.activeTitle;
        }
        if (this.props.disabled) {
            classNames += ' sten-flip-switch--disabled';
        }
        if (this.props.doubleOn) {
            classNames += ' sten-flip-switch--double-on';
        }
        if (this.props.className) {
            classNames += ` ${this.props.className}`;
        }
        if (this.props.size) {
            classNames += this.props.size ? sizeMap[this.props.size] : '';
        }
        if (this.state.isFocused) {
            classNames += ' sten-flip-switch--focused';
        }
        return (
            <div
                className={classNames}
                tabIndex={this.props.tabIndex}
                onClick={this.handleToggle}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                onKeyDown={this.handleKeyDown}
                title={title}
            >
                <div className="sten-flip-switch__value">{value}</div>
                <div className="sten-flip-switch__btn" />
                <div className="sten-flip-switch__values-sizing">{valueLabels.active}</div>
                <div className="sten-flip-switch__values-sizing">{valueLabels.inactive}</div>
                <div style={{ display: 'none' }}>
                    <Checkbox
                        isDisabled={this.props.disabled}
                        name={this.props.name}
                        value={this.props.isActive}
                        isChecked={this.props.isActive}
                    />
                </div>
            </div>
        );
    }
}

FlipSwitch.propTypes = {
    activeLabel: PropTypes.string,
    activeTitle: PropTypes.string,
    allowArrowKeys: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    doubleOn: PropTypes.bool,
    inactiveLabel: PropTypes.string,
    inactiveTitle: PropTypes.string,
    isActive: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    size: PropTypes.string,
    tabIndex: PropTypes.number,
    name: PropTypes.string.isRequired
};

FlipSwitch.defaultProps = {
    activeLabel: 'ON',
    activeTitle: '',
    allowArrowKeys: false,
    className: '',
    disabled: false,
    doubleOn: false,
    inactiveLabel: 'OFF',
    inactiveTitle: '',
    size: '',
    tabIndex: 0
};

export default FlipSwitch;
